import { Component, OnInit, ViewContainerRef, Renderer2 } from '@angular/core';
import { NdmsFormControlComponent } from '../ndms-form-control/ndms-form-control.component';
import { FormBuilder } from '@angular/forms';
import { NdmsTextboxComponent } from '../ndms-textbox/ndms-textbox.component';

@Component({
  selector: 'ndms-email',
  templateUrl: '../ndms-textbox/ndms-textbox.component.html',
  styleUrls: ['./ndms-email.component.scss']
})
export class NdmsEmailComponent extends NdmsTextboxComponent implements OnInit {

  constructor(viewContainerRef: ViewContainerRef ) {
    super(viewContainerRef);
    
    this.placeholder = "email@domain.com";
   }

  ngOnInit() {
  }

  canAddArrayItem(currentIndex: number ){
    return true;
  }

}
